/** @format */

import template from './gb-text-widget.html';

export const GbTextWidgetComponent = {
    template,
    require: {
        gbWidget: '^^',
    },
    controller: class GbTextWidgetComponent {
        constructor() {
            'ngInject';
        }
    },
};
